import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import QRCodeImage from '../assets/qr-code.png';
import ChildLogo from '../assets/CHILDRENDENTISTRY-logo.webp';
import SleepLogo from '../assets/Dental-sleep-care-logo.png';

const { FiPhone, FiMail, FiMapPin, FiGlobe, FiClock } = FiIcons;

export default function Footer() {
  return (
    <footer className="bg-white text-gray-800 pt-8 pb-6 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6">
        {/* Adjusted gap-8 for a tighter grid layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          
          {/* 1. Address Section */}
          <div className="flex flex-col items-start">
            <a href="https://www.dentalsleepcare.in" target="_blank" rel="noreferrer" className="mb-4">
              <img src={SleepLogo} alt="Dental Sleep Care" className="h-14 w-auto object-contain hover:opacity-80 transition-opacity" />
            </a>
            <h3 className="text-lg font-bold mb-2 text-secondary flex items-center gap-2">
              <span className="bg-primary text-white p-1 rounded-full"><SafeIcon icon={FiMapPin} size={14} /></span>
              Address:
            </h3>
            <p className="text-gray-700 leading-relaxed font-medium pl-8 text-sm">
              Nihanya Luxour, Flat A-101,<br />
              Opp. Aparna Heights II,<br />
              Kondapur, Hyd - 500 084.
            </p>
          </div>

          {/* 2. Appointments Section */}
          <div className="flex flex-col border-l-0 md:border-l border-gray-300 md:pl-8">
            <h3 className="text-lg font-bold mb-3 text-secondary">For Appointments:</h3>
            <ul className="space-y-3 font-medium text-gray-700 text-sm">
              <li className="flex items-center gap-3">
                <span className="bg-primary text-white p-1.5 rounded-full"><SafeIcon icon={FiPhone} size={12} /></span>
                <span>040-40055404, +917013686917</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="bg-primary text-white p-1.5 rounded-full"><SafeIcon icon={FiMail} size={12} /></span>
                <a href="mailto:childrendentistry12@gmail.com" className="hover:text-primary transition-colors">childrendentistry12@gmail.com</a>
              </li>
              <li className="flex items-start gap-3">
                <span className="bg-primary text-white p-1.5 rounded-full mt-0.5"><SafeIcon icon={FiGlobe} size={12} /></span>
                <div className="flex flex-col gap-1">
                  <a href="http://child-dent.com" target="_blank" rel="noreferrer" className="hover:text-primary transition-colors">www.child-dent.com</a>
                  <a href="https://www.dentalsleepcare.in" target="_blank" rel="noreferrer" className="hover:text-primary transition-colors">www.dentalsleepcare.in</a>
                </div>
              </li>
            </ul>
          </div>

          {/* 3. Hours & QR Section */}
          <div className="flex flex-col border-l-0 md:border-l border-gray-300 md:pl-8 gap-4">
            <a href="http://child-dent.com" target="_blank" rel="noreferrer">
              <img src={ChildLogo} alt="Childrens Dentistry" className="h-16 w-auto object-contain hover:opacity-80 transition-opacity" />
            </a>
            
            <div className="text-sm">
              <h3 className="text-lg font-bold mb-2 text-secondary flex items-center gap-2">
                <FiClock className="text-primary" /> Clinic Hours:
              </h3>
              <p className="text-gray-600 font-medium">
                <span className="text-primary font-bold">Thusday - Tuesday:</span><br />
                10:00am – 2:00pm & 3:30pm - 7:30pm<br />
                <span className="text-primary font-bold">Wednesday: Closed</span>
              </p>
            </div>

            <div className="flex items-center gap-3">
              <img src={QRCodeImage} alt="Location QR Code" className="w-16 h-16 border border-gray-200 p-1 bg-white rounded shadow-sm" />
              <p className="text-xs font-bold text-gray-800 leading-tight">Scan for<br />Location</p>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-gray-200 pt-4 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-gray-500">
          <p>&copy; {new Date().getFullYear()} Child-Dent & Dental Sleep Care. All rights reserved.</p>
          {/*<div className="flex gap-4">
            <Link to="/privacy-policy" className="hover:text-gray-900">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-gray-900">Terms of Service</Link>
          </div>*/}
        </div>
      </div>
    </footer>
  );
}